import {
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './index.css';

export default function Modal(props){
    return(
        <div className={`modal__container ${props.visible ? 'block': 'hidden'}`}>
            <div className='modal__content w-3/4 flex flex-col m-auto bg-white z-40 p-5 shadow-lg'>
                <div className='modal__header flex flex-row justify-between'>
                    <button className='ml-5' onClick={props.handleModalClose}><FontAwesomeIcon icon={faTimesCircle} size='3x' /></button>
                </div>
                
                <div className='modal__body'>
                    { props.children } 
                </div>
            </div>
            <div className='modal__bg bg-gray-800 opacity-60 absolute w-full h-full z-30' onClick={props.handleModalClose}></div>
        </div>
    );
}